import React, { useRef, useState } from "react";
import "../../Css/YourOrder.css";
import { useCartContext } from "../../context/addToCart";
import { RxCross2 } from "react-icons/rx";
import { message } from "antd";
import emptyCart from "../../Images/add_to_cart.jpg";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const PayOrder = ({ selectedAddress, setSelectedAddress, allAddressData, setAlladdressData }) => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const { cartValue, setCartCount, setCartValue } = useCartContext();
  const profileData = JSON.parse(localStorage.getItem("profile"));
  const tokenid = localStorage.getItem("access_token");
  const navigate = useNavigate();
  console.log("selectedAddress", selectedAddress)
  console.log("profileData", profileData)
  const removeCartData = (index) => {
    setCartValue((prevData) => {
      const updatedData = [...prevData];
      updatedData.splice(index, 1);
      localStorage.setItem("cart", JSON.stringify(updatedData));
      setCartCount(updatedData.length);
      return updatedData;
    });
  };

  const generateOrderId = () => {
    const randomNumber = Math.floor(1000000 + Math.random() * 9000000);
    return `ORDER${randomNumber}`;
  };

  const orderId = generateOrderId();

  // Calculate subtotal
  let finalsubtotal = 0;
  cartValue.forEach((product) => {
    const price = !isNaN(parseFloat(product.product_price)) ? parseFloat(product.product_price) : 0;
    const qty = Number(product.productQuantity) || 0;
    finalsubtotal += price * qty;
  });

  const roundedBasePrice = Math.round(finalsubtotal / 1.18);
  const totaltax = Math.round(finalsubtotal - roundedBasePrice);
  const totalamount = finalsubtotal;
  console.log("cartValue", cartValue)


  const handleOrderSubmission = async () => {
    if (!profileData) {
      message.error("Please Login First");
      return;
    } else if (!selectedAddress) {
      message.error("Select or Add Address First");
      return;
    }

    // Ensure totalamount, finalsubtotal, totaltax are numbers before toFixed
    const grossAmount = parseFloat(totalamount).toFixed(2);
    const totalAmount = parseFloat(finalsubtotal).toFixed(2);
    const taxAmount = parseFloat(totaltax).toFixed(2);
    const payload = {
      user_id: profileData?.id,
      address_id: selectedAddress?.address_id,
      payment_type: "prepaid",
      gross_amount: parseFloat(grossAmount), // Convert back to number if API expects number, otherwise keep as string
      total_amount: parseFloat(totalAmount), // Convert back to number if API expects number, otherwise keep as string
      tax_amount: parseFloat(taxAmount),     // Convert back to number if API expects number, otherwise keep as string
      products: cartValue.map((v) => ({ // CORRECTED: Removed [] from products
        product_id: v?.productId,
        qty: v?.productQuantity,
        price: v?.product_price,
        // Ensure these fields exist in your cartValue items (v)
        main_category_id: '3', // Assuming this property exists in v
        sub_category_id: v?.product_sub_category_id,   // Assuming this property exists in v
        brands_id: v?.productBrandId,
        thickness: v?.productThickness,
        size: v?.productSize,
        tax: v?.productTax, // Assuming this property exists in v
      })),
    };

    console.log("payload", payload);

    try {
      const responseData = await axios.post(
        "https://api.woodsy.co.in/api/wood-orders",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Order submission successful:", responseData.data);
      if (responseData?.data) {
        try {
          setLoading(true);
          if (window.PhonePeCheckout && window.PhonePeCheckout.transact) {
            window.PhonePeCheckout.transact({
              tokenUrl: responseData?.data?.redirectUrl,
              callback: async function (response) {
                if (response === "CONCLUDED") {
                  const formData = new FormData();
                  formData.append("merchantOrderId", responseData?.data?.merchantOrderId);
                  formData.append("orderId", responseData?.data?.orderId);
                  const responsePay = await axios.post(`https://api.woodsy.co.in/api/phonepe/response`, formData); 
                  console.log("responsePay",responsePay)
                  if(responsePay?.data?.data?.state == "COMPLETED"){
                    // alert("Payment done!");
                    window.location.href = `/order-success/${responseData?.data?.merchantOrderId}`;      
                  }else{
                    window.location.href = `/order-failed/${responseData?.data?.merchantOrderId}`;      
                  }
                  console.log("response",responsePay?.data?.data?.state)
                  // alert("Payment done!");
                  // window.location.href = "/payment-success?orderId=${orderId}&moid=${merchantOrderId}";
                } else {
                  alert("Payment cancelled or failed");
                }
              },
              type: "IFRAME", // or 'REDIRECT' for mobile
            });
          } else {
            alert("PhonePeCheckout not available");
          }
        } catch (error) {
          alert("Payment initiation failed");
          console.error(error);
        } finally {
          setLoading(false);
        }
      }

    } catch (error) {
      console.error("Order API error:", error.response ? error.response.data : error.message);
      let errorMessage = "Failed to submit order to Woodsy. Please try again.";

      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.response && error.response.data && error.response.data.errors) {
        // If there are validation errors from Laravel (common for APIs)
        const validationErrors = Object.values(error.response.data.errors)
          .flat()
          .join(', ');
        errorMessage = `Validation Error: ${validationErrors}`;
      }
      message.error(errorMessage);
    }
  };

  return (
    <>
      {cartValue.length <= 0 ? (
        <div className="YourOrder-Con-Main">
          <div className="txt" id="txt">
            <b>1</b><b>F</b><b>I</b><b>V</b><b>E</b>
          </div>
          <div className="checkout-page-cart-empty-imaeg-main-con">
            <div className="checkout-page-cart-empty-imaeg-con">
              <img src={emptyCart} alt="emptyCart" />
            </div>
          </div>
          <div className="plz-add-product-into-cart">
            <h3>Add Product Into Cart</h3>
          </div>
        </div>
      ) : (
        <div className="YourOrder-Con-Main">
          <div className="YourOrder-Con-head-Main">
            <h2>Your Order</h2>
          </div>
          <div className="YourOrder-Con-Title-Main">
            <h2>Product</h2>
            <h2>Total</h2>
          </div>
          <div className="Product-addedCart-Side-Bar">
            {cartValue.map((elem, index) => (
              <div className="Product-addedCart-Side-details" key={index}>
                <div className="Product-addedCart-Image-con">
                  <div className="Product-addedCart-Image">
                    <img
                      src={elem.productImage || "/fallback-image.png"}
                      alt={elem.productBrand || "Product Image"}
                    />
                  </div>
                </div>
                <div className="Product-details-addedCart-price-name">
                  <h2>{elem.productBrand}</h2>
                  {elem.productSize && <h3><span>Size : {elem.productSize}</span></h3>}
                  <h3><span>Quantity : {elem.productQuantity}</span></h3>
                  {elem.productThickness && <h3><span>Thickness : {elem.productThickness}</span></h3>}
                  <h3><span>Price : </span>{elem.product_price ? `${elem.product_price} ₹` : "N/A"}</h3>
                </div>
                <div className="Product-details-addedCart-cancel-btn">
                  <div
                    className="Product-details-addedCart-cancel-btn-con"
                    onClick={() => removeCartData(index)}
                  >
                    <RxCross2 />
                  </div>
                </div>
              </div>
            ))}

            <div className="Product-addedCart-Side-details-1">
              <h3>Hassle-free shopping – Price includes 18% GST!</h3>
              <div className="YourOrder-Con-details-Main">
                <div className="YourOrder-Con-details-text">
                  <h2 className="YourOrder-totoal">Subtotal</h2>
                </div>
                <h2>₹ {finalsubtotal.toFixed(2)}</h2>
              </div>
              <div className="YourOrder-Con-details-Main">
                <div className="YourOrder-Con-details-text">
                  <h2 className="YourOrder-totoal">Base Price</h2>
                </div>
                <h2>₹ {roundedBasePrice}</h2>
              </div>
              <div className="YourOrder-Con-details-Main">
                <div className="YourOrder-Con-details-text">
                  <h2 className="YourOrder-totoal">Tax</h2>
                </div>
                <h2>₹ {totaltax}</h2>
              </div>
              <div className="YourOrder-Con-details-Main">
                <div className="YourOrder-Con-details-text">
                  <h2 className="YourOrder-totoal">Total Amount</h2>
                </div>
                <h2>₹ {Math.round(totalamount)}</h2>
              </div>
            </div>

            <div className="Product-details-Addedcart-btn">
              <div className="Product-details-Addedcart-btn-ViewCart">
                <button type="button" onClick={handleOrderSubmission}>
                  Place Your Order and Pay
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PayOrder;
